import { useState } from "react";
import endpoint from "./Axios";

const usePayAxios = ({
  api,
  method,
  showSuccessMessage = true,
  skipSuccessMessage,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const reset = () => {
    setData(null);
    setLoading(false);
  };

  const onCall = async ({ data, headers, params }) => {
    setLoading(true);
    try {
      let result;

      const shouldSkipSuccessMessage =
        typeof skipSuccessMessage === "boolean"
          ? skipSuccessMessage
          : !showSuccessMessage;

      const config = {
        headers,
        params,
        skipSuccessMessage: shouldSkipSuccessMessage,
      };

      if (method === "get") {
        result = await endpoint.get(api, config);
      } else {
        result = await endpoint[method](api, data, config);
      }

      setData(result.data);
      setLoading(false);
      return result.data;
    } catch (err) {
      setData(null);
      setLoading(false);
      return Promise.reject(err);
    }
  };

  return {
    loading,
    data,
    reset,
    onCall,
  };
};

export default usePayAxios;
